import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const usersApi = {};

usersApi.getUserByAuth0Id = async (auth0Id) => {
  try {
    // encodeURIComponent is needed for this param because the auth0 id contains a | which Safari won't encode automatically
    const response = await axios.get(
      `${consumerBaseUrl}/users/auth0/${encodeURIComponent(auth0Id)}`
    );
    logger.info(response.data);
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

usersApi.createHistoricalLogin = async (auth0Id) => {
  try {
    const body = {
      auth0_user_id: auth0Id,
    };

    const response = await axios.post(
      `${consumerBaseUrl}/patient_portal/historical_ptp_logins`,
      body
    );
    logger.info(response.data);
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};
export default usersApi;
